module.exports = __webpack_public_path__ + "img/yabukita-b.89f666bf.jpg";